{
  "title": "Лоббии бозиҳо",
  "subtitle": "Ҳамаи бозиҳои каталоги Aggregator дар ин ҷо дастрасанд.",
  "searchPlaceholder": "Ҷустуҷӯи бозӣ",
  "categories": "Категорияҳо",
  "all": "Ҳама",
  "slots": "Слотҳо",
  "live": "Казинои зинда",
  "crash": "Crash",
  "instant": "Instant",
  "table": "Миз",
  "other": "Дигар",
  "popular": "Маъмул",
  "new": "Нав",
  "jackpot": "Ҷекпот",
  "tags": "Филтрҳо",
  "providers": "Провайдерҳо",
  "emptyTitle": "Бозиҳо ҳанӯз дастрас нестанд",
  "emptyBody": "Каталоги провайдерҳо ҳамоҳанг нашудааст. Бозиҳои ҳақиқӣ ё демо танҳо пас аз ҳамгироии тасдиқшуда фаъол мешаванд.",
  "errorTitle": "Каталог бор нашуд",
  "errorBody": "Ҳангоми гирифтани рӯйхати бозиҳо хато рӯй дод. Баъдтар дубора кӯшиш кунед.",
  "notPlayable": "Ҳоло кушода намешавад",
  "demoUnavailable": "Демо ҳанӯз фаъол нест",
  "realMoneyDisabled": "Бозиҳои пулӣ ғайрифаъоланд",
  "provider": "Провайдер",
  "results": "{{count}} бозӣ",
  "featured": "Интихобшуда",
  "lobbySection": "Каталог",
  "allProviders": "Ҳамаи провайдерҳо",
  "sort": "Мураттабсозӣ",
  "sortRecommended": "Тавсияшуда",
  "sortName": "Ном",
  "sortProvider": "Провайдер",
  "favorite": "Дӯстдошта",
  "selectWallet": "Пеш аз бозӣ балансро интихоб кунед",
  "realBalance": "Баланси асосӣ",
  "bonusBalance": "Баланси бонус",
  "fundingLocked": "Баланси интихобшуда дар тамоми сессияи бозӣ нигоҳ дошта мешавад. Маблағҳои ҳақиқӣ ва бонус омехта намешаванд.",
  "launchPlay": "Бози кардан",
  "bonusNotSlot": "Бонус танҳо дар слотҳои тасдиқшуда истифода мешавад",
  "bonusPlayDisabled": "Бозии бонус ҳанӯз фаъол нест",
  "sessionFundingUnsupported": "Провайдер манбаи маблағгузории сессияро бехатар нигоҳ дошта натавонист. Ин режим баста шуд.",
  "loginToPlay": "Барои бозӣ ворид шавед",
  "sessionLaunched": "Сессияи бозӣ сохта шуд",
  "loadMore": "Бештар нишон додан",
  "loadingMore": "Бор мешавад…",
  "showingOf": "{{shown}} / {{total}} бозӣ",
  "launchDemo": "ДЕМО БОЗӢ",
  "launchReal": "БО БАЛАНСИ ВОҚЕӢ БОЗӢ",
  "launchBonus": "БО БАЛАНСИ БОНУС БОЗӢ",
  "demoLaunched": "Сессияи демо сохта шуд",
  "history": "Таърихи бозӣ",
  "searchResults": "Ҷустуҷӯ",
  "bonusContinueTitle": "Бо бонус давом?",
  "bonusContinueBody": "Баланси асосӣ 0. Бонус ҳаст — танҳо бо интихоби шумо.",
  "openExternal": "Бозӣ кушоед",
  "openExternalHint": "Агар бозӣ дарун кушода нашавад, тугмаро пахш кунед.",
  "backToCatalog": "Ба каталог",
  "notFound": "Бозӣ ёфт нашуд",
  "recommended": "Тавсияшуда",
  "fastGames": "Бозиҳои зуд",
  "bonusWager": "Бо бонус шарт"
}
